// Event-bus channel name for value-moment-triggered push priming (gap G6).
//
// Kept in a leaf-level constants file so emitter components (DepositSheet,
// VariantItemsEditor) don't pull the full usePushNotifications.js dependency
// graph (platform adapter → usePwa → vite-plugin-pwa virtual module) into
// their compiled chunks or test runs.
//
// Payload shape: `{ moment }` — a moment of the user's club
// (`engagement.pushMoments`, clubs/manifest.js): sellers 'orderbox' | 'deposit' |
// 'registration' | 'profile_status'; suppliers 'claim' | 'withdrawal' |
// 'box_confirmed' | 'profile_status'.
// App.vue is the single subscriber.
export const PUSH_PRIMING_TRIGGER_EVENT = 'push:trigger-priming';

// ── Welcome push — locked AR copy ────────────────────────────────────────────
// Fired locally (via SW registration.showNotification) immediately after a new
// push subscription is created. Triggers on EVERY new subscription event:
//   - first-ever subscribe
//   - unsubscribe → resubscribe on the same device
//   - existing user subscribes a new device
// Copy is locked (poolit-voice). Only translators / the poolit-voice agent
// should edit these strings.
//
// One entry per `engagement.welcomePush` key in clubs/manifest.js;
// triggerWelcomePush picks the entry by the user's club and sends nothing for
// a `null` entry. Both entries are locked poolit-voice copy.
export const WELCOME_PUSH_COPY = Object.freeze({
  sellers: Object.freeze({
    title: '🔔 النادي وصّلك — وده بس البداية',
    body: 'اوردراتك وفلوسك ومواعيدك — كلها هتوصلك في اللحظة الصح. أهلاً بك في نادي السيلرز 💖',
    url: '/home/',
    // Standard PWA icon — matches manifest.webmanifest 192×192 entry.
    icon: '/pwa-192x192.png',
  }),
  suppliers: Object.freeze({
    title: '🔔 أهلاً بك في نادي الموردين',
    body: 'رد النادي على الاوردرات اللي سحبتها، وتأكيد اوردرات محلك، وحركة محفظتك — كلها هتوصلك في لحظتها 💖',
    url: '/suppliers/',
    icon: '/pwa-192x192.png',
  }),
});

// The sellers entry under its original names, kept for existing importers.
export const WELCOME_PUSH_TITLE = WELCOME_PUSH_COPY.sellers.title;
export const WELCOME_PUSH_BODY = WELCOME_PUSH_COPY.sellers.body;
export const WELCOME_PUSH_URL = WELCOME_PUSH_COPY.sellers.url;
export const WELCOME_PUSH_ICON = WELCOME_PUSH_COPY.sellers.icon;

// localStorage key for per-subscription dedup (see triggerWelcomePush).
export const WELCOME_PUSH_LAST_SENT_KEY = 'poolit:push-last-welcome-at';
